import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Navbar />
      <div className="relative flex flex-col items-center justify-center min-h-[60vh] text-center px-4 pt-24 pb-14">
        <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0 font-heading">
          404
        </h1>
        <div className="relative z-10">
          <i className="ri-error-warning-line text-5xl md:text-6xl text-primary-400 mb-4"></i>
          <h1 className="text-xl md:text-2xl font-semibold mt-6 text-foreground-950">
            页面未找到
          </h1>
          <p className="mt-2 text-base text-foreground-400 font-mono">{location.pathname}</p>
          <p className="mt-4 text-sm md:text-base text-foreground-500">
            抱歉，你访问的页面不存在或已被移除
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 mt-6 px-6 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-home-line"></i>
            返回首页
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
}